import container from '../container';

async function getChildPlans({ childId }) {
  return new Promise((resolve, reject) => {
    container
      .queriesController()
      .fetchChildPlans({ childId })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getPlansRememberOptions() {
  return new Promise((resolve, reject) => {
    container
      .queriesController()
      .fetchPlanRememberOptions()
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function createNewPlan({
  where_place,
  what_activities,
  how_remember,
  daysTime,
  whenCheckDays,
  extra_data,
  child,
  module,
}) {
  const requestData = await container
    .commandsController()
    .createNewPlanRequest({
      where_place,
      what_activities,
      how_remember,
      daysTime,
      whenCheckDays,
      extra_data,
      child,
      module,
    });
  const response = {
    plan: {
      id: requestData.data.id,
      where_place: requestData.data.where_place,
      what_activities: requestData.data.what_activities,
      extra_data_how_remember: requestData.data.extra_data,
      what_days: requestData.data.daysTime.map((element) => {
        return {
          day_of_week: element.day,
          hour: element.hour,
          is_when_check_day: false,
          is_active: true,
          day_name: calculeDayName(element.day),
        };
      }),
      when_check_days: requestData.data.whenCheckDays.map((element) => {
        return {
          day_of_week: element.day,
          hour: element.hour,
          is_when_check_day: true,
          is_active: true,
          day_name: calculeDayName(element.day),
        };
      }),
      how_remember_id: requestData.data.how_remember,
      has_extra: requestData.data.extra_data != null,
    },
    coins: requestData.coins,
    description: requestData.description,
    points: requestData.points,
  };
  return response;
}

async function editPlan({
  where_place,
  what_activities,
  how_remember,
  daysTime,
  whenCheckDays,
  extra_data,
  child,
  module,
  planId,
  parentEdit,
}) {
  const requestData = await container
    .commandsController()
    .editPlanRequest({
      where_place,
      what_activities,
      how_remember,
      daysTime,
      whenCheckDays,
      extra_data,
      child,
      module,
      planId,
      parentEdit,
    });
  const response = {
    plan: {
      id: requestData.id,
      where_place: requestData.where_place,
      what_activities: requestData.what_activities,
      extra_data_how_remember: requestData.extra_data_how_remember,
      what_days: requestData.what_days.map((element) => {
        return {
          day_of_week: element.day_of_week,
          hour: element.hour,
          is_when_check_day: element.is_when_check_day,
          is_active: element.is_active,
          day_name: element.day_name,
        };
      }),
      when_check_days: requestData.when_check_days.map((element) => {
        return {
          day_of_week: element.day_of_week,
          hour: element.hour,
          is_when_check_day: element.is_when_check_day,
          is_active: element.is_active,
          day_name: element.day_name,
        };
      }),
      how_remember_id: requestData.how_remember_id,
      has_extra: requestData.has_extra,
    },
  };
  return response;
}

function calculeDayName(dayCode) {
  const days = {
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
    7: 'Sunday',
  };
  return days[dayCode];
}

async function getChildCheckList({ childId, date = null }) {
  return new Promise((resolve, reject) => {
    container
      .queriesController()
      .fetchCheckList({ childId, date })
      .then(({ data }) => {
        data.forEach((element) => {
          element.module['img'] = 'modules-0' + element.module.order;
          const datesResponse = {};
          const datesTypeResponse = {};
          element.dates.forEach((date) => {
            date.items.forEach((item) => {
              item['defParent'] = item['approvedParent'];
              item['defQualifiedParent'] = item['qualifiedParent'];
              item['defChild'] = item['approvedChild'];
            });
            datesResponse[date.date] = date.items;
            datesTypeResponse[`${date.date}-type`] = date.type;
          });
          element.dates = datesResponse;
          element.type = datesTypeResponse;
        });
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getChecklistDates({ childId }) {
  return new Promise((resolve, reject) => {
    container
      .queriesController()
      .fetchChecklistDates({ childId })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function saveChildCriteria({ module, child, items, parent }) {
  return await container.commandsController().addChildCriteria({ module, child, items, parent });
}

async function getAllChecklistInformation({ childId }) {
  const initialDate = new Date().toLocaleDateString('en-CA');
  return new Promise((resolve, reject) => {
    Promise.all([
      container.queriesController().fetchCheckList({ childId, date: initialDate }),
      container.queriesController().fetchChecklistDates({ childId }),
    ])
      .then((result) => {
        const checkListInfo = result[0].data;
        const checkListDates = result[1].data;

        const checkListResult = checkListInfo.map((checkListItem) => {
          const dateItem = checkListDates.find(
            (element) => element.module.module_order == checkListItem.module.module_order,
          );
          const module = {
            ...checkListItem.module,
            img: `modules-0${checkListItem.module.module_order}`,
          };
          let dates = {};
          checkListItem.dates.forEach((date) => {
            const items = date.items.map((item) => {
              return {
                ...item,
                defParent: item['approvedParent'],
                defQualifiedParent: item['qualifiedParent'],
                defChild: item['approvedChild'],
              };
            });
            dates[date.date] = items;
          });
          let result = {
            ...checkListItem,
            module: module,
            dates: dates,
          };
          if (dateItem) {
            result['availableDates'] = dateItem.dates;
          }
          return result;
        });
        resolve(checkListResult);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function createCriterion({ module, childId, description, userId, value, tag }) {
  return await container
    .commandsController()
    .createCriterionRequest({ module, childId, description, userId, value, tag });
}

async function updateCriterion({ itemId, name, coin_value }) {
  return await container.commandsController().updateCriterionRequest({ itemId, name, coin_value });
}

async function deleteCriterion({ criterionId }) {
  return await container.commandsController().deleteCriterion({ criterionId });
}

async function childApproveCriterion({ items, date }) {
  return await container.commandsController().childApproveCriterionRequest({ items, date });
}

async function parentApproveCriterion({ items, date, child }) {
  let data = await container
    .commandsController()
    .parentApproveCriterionRequest({ items, date, child });
  return data;
}

function getFormattedDate(strdate, replaceTimeZone = false) {
  strdate = strdate.toString();
  if (replaceTimeZone || strdate.search('T') == -1) {
    let today = new Date();
    today.setHours(0, 0, 0);
    let strDateParts = strdate.split('T');
    let strTodayParts = today.toISOString().split('T');
    strdate = strDateParts[0] + 'T' + strTodayParts[1];
  }
  let date = new Date(strdate);
  let day = date.getDate();
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  let dayName = days[date.getDay()];
  let monthName = months[date.getMonth()];
  day = day < 10 ? '0' + day : day;
  let formatted = `${dayName}, ${monthName} ${day}`;
  return formatted;
}

async function acceptOrRejectItemChecklist({ id, childId, isAccept }) {
  try {
    return await container
      .commandsController()
      .acceptOrRejectItemChecklist({ id, child: childId, value: isAccept });
  } catch (error) {
    throw new Error('[Checklist]: Ups!, i have a problem when try accept or reject the item');
  }
}

async function editItemOrder(childId, newOrderCheckList) {
  const dataItem = { items: newOrderCheckList };
  try {
    return await container.commandsController().editItemOrder({ childId, dataItem });
  } catch (error) {
    throw new Error('[Service]: Oops!, I could not edit the project.');
  }
}

async function getCriterionTagsList() {
  try {
    return await container.queriesController().fetchCriterionTagsList();
  } catch (error) {
    throw new Error('[Service]: Oops!, Cannot obtain the tags.');
  }
}

export {
  calculeDayName,
  getChildPlans,
  getPlansRememberOptions,
  createNewPlan,
  editPlan,
  getChildCheckList,
  getChecklistDates,
  saveChildCriteria,
  getAllChecklistInformation,
  createCriterion,
  childApproveCriterion,
  parentApproveCriterion,
  updateCriterion,
  deleteCriterion,
  getFormattedDate,
  acceptOrRejectItemChecklist,
  editItemOrder,
  getCriterionTagsList,
};
